import EntityEnum from "@/entities/entityEnum";

export default class UserQualificationType extends EntityEnum {}
